import { configureStore } from "@reduxjs/toolkit";

import common from "../features/admin/common/Slice";

import contactus from "./contactus";

import auth from "./auth";

import product from "./product";

import kycverification from "./kycverification";

//store
export const store = configureStore({
  reducer: {
    common: common,

    contactus,

    auth,

    product,
    kycverification,
  },
});
